<template>
  <div v-show="isWinnersUserDisplayed" ref="winnersUserRef" class="prize_user_row">
    <div
      class="user_img_bg"
      :style="isVisitDetailsPageBlocked ? 'cursor: default': ''"
      @click="goToUserDetailsPage"
    >
      <base-avatar-image :src="user.avatar"></base-avatar-image>
    </div>

    <div class="col_mobile">
      <div class="user_info">
        <p
          class="name"
          :style="isVisitDetailsPageBlocked ? 'cursor: default': ''"
          @click="goToUserDetailsPage"
        >
          {{ userUsername }}
        </p>

        <p class="cash">{{ userRewardDescription }}</p>
      </div>

      <div class="date_box">
        <p class="date_txt">{{ getTranslations.winners_page_prize_date }} </p>

        <p class="date">{{ userRewardDate | formatDateFilter }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import $ from 'jquery'
import moment from 'moment'
import BaseAvatarImage from './common/image/BaseAvatarImage.vue'

export default {
  name: 'WinnersUserListItem',
  components: {BaseAvatarImage},
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatDateFilter: date => {
      if (date) {
        moment.locale(localStorage.getItem('locale'))
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  data () {
    return {
      isWinnersUserDisplayed: false
    }
  },
  mounted () {
    this.renderUser()
  },
  computed: {
    ...mapState('common', [
      'userDetails'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    userUsername () {
      return this.user.username || ''
    },
    userRewardDescription () {
      return this.user.rewardDescription || ''
    },
    userRewardDate () {
      return this.user.rewardDate || ''
    },
    isVisitDetailsPageBlocked () {
      return this.user.hasPrivateProfile ||
        !this.user.isWebUser ||
        this.user.msisdn === this.userDetails.msisdn ||
        !localStorage.getItem('jwtToken')
    }
  },
  methods: {
    async renderUser () {
      if (this.animated) {
        await this.$nextTick()

        if (this.$refs.winnersUserRef) {
          /**
           * Used jQuery in order to call the 'slideDown' method.
           * The 'slideDown' will change the 'display' value (on init it is 'none' (ref. 'v-show='isWinnersUserDisplayed'' in template))
           * and display the matched element with a sliding motion.
           *
           * No need to change the 'isWinnersUserDisplayed' value in that case.
           */
          $(this.$refs.winnersUserRef).slideDown()

          return
        }
      }

      this.isWinnersUserDisplayed = true
    },
    goToUserDetailsPage () {
      if (this.isVisitDetailsPageBlocked) { return }

      localStorage.setItem('rankUserPageInfo', JSON.stringify({id: this.user.msisdn, prevPageName: 'winnersAuth'}))
      this.$router.push({name: 'rankUserStats'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WinnersUserListItem.vue